const { SHOW_ERROR_LOGGING } = process.env;

export const logError = (error) => {
  if (!SHOW_ERROR_LOGGING) return;

  console.error('Application Error: ', error);
};
